import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { createI18n } from 'vue-i18n'
import { initFlowbite } from 'flowbite'
import './assets/main.css'

loadFonts()

import en from './locales/en.json'
import th from './locales/th.json'

// ตั้งค่า i18n
const i18n = createI18n({
  locale: 'en',
  messages: { en, th },
})

const app = createApp(App)

app.use(store)
app.use(router)
app.use(vuetify)
app.use(VueSweetalert2)
app.use(i18n)

initFlowbite()

app.mount('#app')
